import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { createPortal } from "react-dom";
import TestTemas from "../../pages/TestTemas";
import { getMessage } from "../../data/locales";
import { parseTestTemasLaunchQuery } from "../../utils/parseTestTemasLaunchQuery";

/**
 * Runs TestTemas over Campus without changing the browser URL.
 * Must not mount a nested Router — the app already has BrowserRouter.
 */
export default function CampusTestOverlay({ launchHref, onClose }) {
  const embeddedQuery = useMemo(
    () => parseTestTemasLaunchQuery(launchHref),
    [launchHref],
  );

  return createPortal(
    <div className="campus-test-overlay" role="dialog" aria-modal="true" aria-label={getMessage("tests.practice")}>
      <button
        type="button"
        className="campus-test-overlay-close"
        onClick={onClose}
        aria-label={getMessage("campus.backToCampus")}
      >
        ×
      </button>
      <div className="campus-test-overlay-body">
        <TestTemas embeddedQuery={embeddedQuery} onEmbeddedClose={onClose} />
      </div>
    </div>,
    document.body,
  );
}

CampusTestOverlay.propTypes = {
  launchHref: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};
